import { render, staticRenderFns } from "./mydealList.vue?vue&type=template&id=748c59a3&scoped=true&"
import script from "./mydealList.vue?vue&type=script&lang=js&"
export * from "./mydealList.vue?vue&type=script&lang=js&"
import style0 from "./mydealList.vue?vue&type=style&index=0&id=748c59a3&scoped=true&lang=css&"
import style1 from "./mydealList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c59a3",
  null
  
)

export default component.exports